import HeaderOther from "../ui/header-other";
import './terms-and-conditions.css';

export default function TermsAndConditions() {

    return (
        <>
            <HeaderOther title="Terms & Conditions" description="Terms of use"/>
            <div className='privacy-policy-page'>
                <div className='privacy-policy-card'>
                    <div className='privacy-policy-hero'>
                        <p className='privacy-policy-title'>Terms and Conditions for freslo (formerly OnTimeUrban): The Instant Wholesaler</p>
                        <p className='privacy-policy-subtitle'>Effective Date: January 15, 2025</p>
                        <p className='privacy-text'>Welcome to freslo (formerly OnTimeUrban)! By using our website, mobile application, or services, you agree to comply with the following Terms and Conditions. Please read them carefully before accessing or using our platform.</p>
                    </div>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Introduction</p>
                        <p className='privacy-text'>freslo (formerly OnTimeUrban) is a platform that sells grocery items, gadgets, and daily needs, offering delivery within 15 minutes in Hazaribagh, Jharkhand. These Terms govern your use of our services.</p>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Eligibility</p>
                        <p className='privacy-text'>To use our services, you must:</p>
                        <ul className='privacy-list'>
                            <li>Be at least 18 years old or have parental consent.</li>
                            <li>Provide accurate and complete information during registration.</li>
                        </ul>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Account Registration</p>
                        <ul className='privacy-list'>
                            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
                            <li>Notify us immediately of any unauthorized access to your account.</li>
                            <li>freslo (formerly OnTimeUrban) reserves the right to suspend or terminate accounts for fraudulent or unauthorized activities.</li>
                        </ul>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Placing Orders</p>
                        <ul className='privacy-list'>
                            <li>Orders can be placed via our website or mobile application.</li>
                            <li>Availability of products is subject to stock levels.</li>
                            <li>Orders are processed only after successful payment confirmation.</li>
                        </ul>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Pricing and Payment</p>
                        <p className='privacy-text'>All prices are displayed in INR and include applicable taxes. Payment methods include credit/debit cards, UPI, and other available options. freslo (formerly OnTimeUrban) reserves the right to modify prices without prior notice.</p>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Delivery Policy</p>
                        <ul className='privacy-list'>
                            <li>Delivery is available exclusively in Hazaribagh, Jharkhand.</li>
                            <li>We aim to deliver orders within 15 minutes of confirmation.</li>
                            <li>Delays may occur due to unforeseen circumstances, such as weather or traffic conditions.</li>
                        </ul>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Cancellation and Refunds</p>
                        <p className='privacy-text'><b>a. Cancellation</b></p>
                        <ul className='privacy-list'>
                            <li>Orders can be canceled before they are dispatched.</li>
                            <li>freslo (formerly OnTimeUrban) reserves the right to cancel orders due to stock unavailability or payment issues.</li>
                        </ul>
                        <p className='privacy-text'><b>b. Refunds</b></p>
                        <ul className='privacy-list'>
                            <li>Refunds for canceled orders will be processed within 7 working days.</li>
                            <li>Refunds will be credited to the original payment method.</li>
                        </ul>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Product Returns and Replacements</p>
                        <ul className='privacy-list'>
                            <li>Returns are accepted for damaged or defective products within 48 hours of delivery.</li>
                            <li>Replacements are subject to product availability.</li>
                            <li>To initiate a return or replacement, contact our support team with proof of purchase.</li>
                        </ul>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Prohibited Activities</p>
                        <p className='privacy-text'>When using our services, you agree not to engage in fraudulent activities or provide false information, use our platform for illegal or unauthorized purposes, or interfere with the operation of our website, app, or services.</p>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Intellectual Property</p>
                        <ul className='privacy-list'>
                            <li>All content on freslo (formerly OnTimeUrban)’s platform, including logos, text, images, and designs, is protected by copyright and trademark laws.</li>
                            <li>Unauthorized use of our intellectual property is prohibited.</li>
                        </ul>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Limitation of Liability</p>
                        <p className='privacy-text'>freslo (formerly OnTimeUrban) is not liable for delays in delivery caused by factors beyond our control, loss or damage arising from unauthorized account access, or indirect, incidental, or consequential damages.</p>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Indemnification</p>
                        <p className='privacy-text'>You agree to indemnify and hold freslo (formerly OnTimeUrban) harmless from any claims, damages, or expenses arising from your use of our services or violation of these Terms.</p>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Modification of Terms</p>
                        <p className='privacy-text'>freslo (formerly OnTimeUrban) reserves the right to update or modify these Terms at any time. Changes will be posted on this page, and your continued use of our services constitutes acceptance of the updated Terms.</p>
                    </section>

                    <section className='privacy-section'>
                        <p className='privacy-section-title'>Governing Law and Jurisdiction</p>
                        <p className='privacy-text'>These Terms are governed by the laws of India. Any disputes will be resolved exclusively in the courts of Hazaribagh, Jharkhand.</p>
                    </section>

                    <section className='privacy-section privacy-contact-section'>
                        <p className='privacy-section-title'>Contact Us</p>
                        <p className='privacy-text'>If you have any questions or concerns about these Terms and Conditions, please contact us at:</p>
                        <p className='privacy-text privacy-contact-item'><span>Email:</span> ontimeurban@gmail.com</p>
                        <p className='privacy-text privacy-contact-item'><span>Phone:</span> +91-7481016483</p>
                        <p className='privacy-text privacy-contact-item'><span>Address:</span> Hazaribagh, Jharkhand, India</p>
                    </section>
                </div>
            </div>
        </>
    );
}


